import { Link } from "react-router-dom";
//import { colorHash } from '../recordlist';

export const colorHash = (string : string): string => {
    let hash = 0;
    var char;
     
    if (string.length === 0) return hash.toString();
    
    for (var i = 0; i < string.length; i++) {
        char = string.charCodeAt(i);
        hash = ((hash << 5) - hash) + char;
        hash = hash & hash;
    }
    
    var positive = Math.abs(hash);
    return "#" + (positive & 0x00FFFFFF).toString(16).padStart(6, '0');
};

const doColor = (name : string, location : string): string => {
    if (!name || name === 'None' || !location || location === 'None') return '#ffffff';
    //return '#ffffff';
	return colorHash(name + "-" + location);
};

export const SeasonsTable = ({ title, list } : {title : any, list : any}) => {
	return (
		<div>
			<h3>{title}</h3>
			<table width='70%' style={{border: '1'}} className={"seasonListTable"}>
				<thead style={{backgroundColor: '#22ccee'}}>
					<tr style={{textAlign: 'right'}}>
						<td width='9%' align='left'><strong>Name</strong></td>
						<td width='10%' align='left'><strong>Start Date</strong></td>
						<td width='10%' align='left'><strong>End Date</strong></td>
						<td width='55%' align='left'><strong>Prize</strong></td>
						<td width='10%' align='left'><strong>Winner</strong></td>
						<td width='6%' align='left'><strong>Entries</strong></td>
					</tr>
				</thead>
			{list.map((s : any) => (
				<tbody key={s.seasonId} >
					<tr style={{textAlign: 'right'}}>
						<td align='left'>{s.seasonName}</td>
						<td align='left'>{s.seasonStartDate}</td>
						<td align='left'>{s.seasonEndDate}</td>
						<td align='left'>{s.prize}</td>
						<td align='left' style={{backgroundColor: doColor(s.winnerName, s.winnerLocation) }}>{s.winnerName}<br />{s.winnerLocation}</td>
						<td><Link to={`/recordlist/${s.seasonId}`} key={s.seasonId}>{s.recordCount}</Link></td>
					</tr>
				</tbody>
			))}
			</table>
			<br />
		</div>
	);
};
